<template>
    <button
        :disabled="disabled"
        :type="isEmpty(elementType) ? false : elementType"
        v-bind:class="getClasses()"
        @click="routeClick"
    >
        <slot />
    </button>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        smallMode: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'success',
        },
        pull: {
            type: String,
            default: '',
        },
        andClasses: {
            type: Array,
            default: () => [],
        },
        loading: {
            default: false,
        },
        elementType: {
            type: String,
            default: '',
        },
        block: {
            type: Boolean,
            default: false,
        },
        to: {
            type: Object,
            default: () => {},
        },
        skipRippleAnimation: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        isEmpty,
        getClasses() {
            let classes = ['btn']

            classes.push('btn-' + this.type)

            if (this.smallMode) {
                classes.push('btn-sm')
            }

            if (!isEmpty(this.pull)) {
                classes.push('pull-' + this.pull)
            }

            if (this.andClasses.length) {
                classes = [...classes, ...this.andClasses]
            }

            if (this.loading) {
                classes.push('loading')
            }

            if (this.block) {
                classes.push('btn-block')
            }

            return classes
        },
        routeClick(e) {
            if (!this.skipRippleAnimation) {
                this.createRipple(e)
            }

            if (isEmpty(this.to)) {
                this.$emit('click', e)

                return
            }

            this.$router.push(this.to)
        },
        createRipple(e) {
            let button = this.$el
            let buttonBounding = button.getBoundingClientRect()

            let circle = document.createElement('span')
            let diameter = Math.max(button.clientWidth, button.clientHeight)
            let radius = diameter / 2

            circle.style.width = circle.style.height = diameter + 'px'
            circle.style.left = event.clientX - buttonBounding.x - radius + 'px'
            circle.style.top = event.clientY - buttonBounding.y - radius + 'px'

            circle.classList.add('ripple')

            let existing = button.getElementsByClassName('ripple')

            if (existing.length) {
                existing[0].remove()
            }

            button.appendChild(circle)
        },
    },
}
</script>
